import { MappedClass, MappedProperty, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterInt32Applicable } from './z-printer-int32-applicable';
import { ZPrinterMeanTypeApplicable } from './z-printer-mean-type-applicabile';
import { ZPrinterStringApplicable } from './z-printer-string-applicable';
import { ZPrinterVatTypeApplicable } from './z-printer-vat-type-applicable';

@MappedClass()
export class ZPrinterFiscalConfigVat {
  @MappedProperty()
  index: number;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  percentage: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  name: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterVatTypeApplicable)
  type: ZPrinterVatTypeApplicable;

  @MappedPropertyClass(() => ZPrinterMeanTypeApplicable)
  mean: ZPrinterMeanTypeApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  ateco: ZPrinterStringApplicable;

  @MappedProperty()
  rch_vat_type: string;
}
